import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../../lib/i18next";
import { OWNER_AD_SPEND_TREND_NEW } from "../../../../i18n/keysTranslations";
import { formatAdSpendPercent } from "./adSpendDisplay";

const UP_SX = {
  backgroundColor: "#e6f4ea",
  color: "#137333",
  fontWeight: 600,
  height: 22,
};

const DOWN_SX = {
  backgroundColor: "#fce8e6",
  color: "#a50e0e",
  fontWeight: 600,
  height: 22,
};

const AdSpendTrendChip = ({ trend = null }) => {
  const { t, i18n } = useTranslationApp();

  if (!trend) return null;

  if (trend.isNew) {
    return <Chip size="small" label={t(OWNER_AD_SPEND_TREND_NEW)} sx={UP_SX} />;
  }

  if (trend.direction === "flat") {
    return (
      <Typography variant="body2" color="text.secondary" component="span">
        —
      </Typography>
    );
  }

  const isUp = trend.direction === "up";
  const percent = formatAdSpendPercent({
    percent: Math.abs(Number(trend.deltaPercent) || 0),
    language: i18n.language,
  });

  return (
    <Chip
      size="small"
      label={isUp ? `▲ ${percent}` : `▼ ${percent}`}
      sx={isUp ? UP_SX : DOWN_SX}
    />
  );
};

export default AdSpendTrendChip;
